// extracted by mini-css-extract-plugin
export default {"planConnector":"ConfirmStep_planConnector__Y-1L5","planConnectorIcon":"ConfirmStep_planConnectorIcon__0LkqU"};